export default "__VITE_ASSET__eba6dd43__"